module.exports = __webpack_public_path__ + "img/creator.1776ef79.svg";